<template>
  <div>
    <footer>
      <div class="footer-top">
        <div class="top-con">
          <div class="footer-left">
            <div class="footer-top-tit">联系我们</div>
            <div class="site">
              <div class="item" style="width: 35%;">
                <!-- <div class="item-tit">上海总部</div> -->
                <div class="item-con">
                  <div class="list">
                    <div class="list-tit">咨询热线</div>
                    <div class="list-tit">010-6358-5582</div>
                  </div>
                </div>
              </div>

              <div class="item" style="width: 57%;">
                <!-- <div class="item-tit">江苏工厂</div> -->
                <div class="item-con">
                  <div class="list">
                    <div class="list-tit" style="font-size: 14px;">咨询电话 <span>17200372243</span>
                    </div>
                  </div>
                  <div class="list">
                    <div class="list-tit" style="font-size: 14px;">企业邮箱 <span>zhn@bjznhk.cn</span> </div>
                    <div class="list-tit"></div>
                  </div>
                  <div class="list">
                    <div class="list-tit" style="font-size: 14px;">公司地址 <span>北京市东城区东打磨厂街7号宝鼎中心A座1101室</span> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="footer-right">
            <!-- <div class="footer-top-tit">关注我们</div> -->
            <!-- <div class="hr-line"></div> -->
            <div class="erweima-list">
              <div>
                <img class="erweima" :src="erweima">
                <p>项目经理--卢云涛</p>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="copyright">
          CopyRight@2018 ZHONGNENGHANGKE ALL RIGHTS RESERVERD 北京中能航科科技有限公司 版权所有
          <a href="https://beian.miit.gov.cn" target="_blank"> 备案号: 京ICP备2024042019号-1</a>
        </div>
      </div>

    </footer>

  </div>
</template>

<script>
// 导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
export default {
  name: 'Head',
  components: {

    // import引入的组件需要注入到对象中才能使用
  },
  data() {
    return {
      erweima: require("@/assets/img/erweima.jpg"),
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style scoped lang="less">
.fixd {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: space-Between;
  -webkit-justify-content: space-Between;
  -moz-box-pack: space-Between;
  -ms-flex-pack: space-Between;
  justify-content: space-Between;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

footer {
  background: #2895EA;
  padding-top: 52px;

  .footer-top {
    padding-bottom: 53px;

    .top-con {
      width: 1000px;
      margin: 0 auto;
      .fixd();

      .footer-left {
        width: 78%;

        .site {
          .item {
            display: inline-block;
            vertical-align: top;
            width: 43%;

            .item-tit {
              font-size: 14px;
              line-height: 24px;
              color: #7fbe25;
              margin-top: 17px;
              margin-bottom: 17px;
            }

            .item-con {
              .list {
                .list-tit {
                  font-size: 18px;
                  color: #FFF;
                  margin-bottom: 7px;

                  span {
                    margin-left: 40px;
                  }
                }

                .list-con {
                  font-size: 14px;
                  line-height: 24px;
                  color: #FFF;
                  padding-left: 43px;
                }
              }

            }
          }

          .item:last-child {
            margin-right: 0;
          }
        }
      }

      .footer-top-tit {
        font-size: 26px;
        line-height: 32px;
        color: #fff;
        margin-bottom: 21px;
      }

      .erweima-list {
        color: #fff;

        p {
          margin-top: 6px;
          text-align: center;
        }

        img {
          padding: 2px;
          width: 100px;
        }
      }
    }
  }

  .footer-bottom {
    color: #FFF;
    border-top: 1px solid rgba(255,255,2555,0.4);
    margin: 0 auto;
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: center;

    a {
      cursor: pointer;
    }
  }



  a {
    color: #FFF;
  }
}

@media screen and (max-width: 1366px) {
  footer {
    background: #2895EA;
    padding-top: 52px;

    .footer-top {
      padding-bottom: 53px;

      .top-con {
        width: 1000px;
      }
    }
    .footer-bottom {
      width: 1000px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue